import { useState, useRef, useCallback } from 'react';

/**
 * Returns event handlers and anchor ref that show a tooltip only after the
 * mouse has been stationary over the element for `delay` ms. Any mouse
 * movement resets the timer. The anchorRef should be attached to the card
 * element so portal-based tooltips can calculate their position.
 */
const useStationaryTooltip = (delay = 400) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const timerRef = useRef(null);
    const anchorRef = useRef(null);

    const resetTimer = useCallback(() => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setTooltipVisible(true), delay);
    }, [delay]);

    const cancel = useCallback(() => {
        clearTimeout(timerRef.current);
        setTooltipVisible(false);
    }, []);

    return {
        tooltipVisible,
        anchorRef,
        onMouseEnter: resetTimer,
        onMouseMove: resetTimer,
        onMouseLeave: cancel,
    };
};

export default useStationaryTooltip;
